import {
  getTransactionDateColumn,
  getCounterpartyNameColumn,
  getCounterPartyAccountNumberColumn,
  getTransactionDescriptionColumn,
  getIncomeColumn,
  getExpenseColumn,
  getRateColumn,
  getBalanceColumn,
  getDeleteActionColumn,
} from "./statementColumnsHelpers"; // adjust path

export function createReportStatementColumns({ currency, onDelete }) {
  return [
    getTransactionDateColumn(),
    getCounterpartyNameColumn(),
    getCounterPartyAccountNumberColumn({ copyable: true }),
    getTransactionDescriptionColumn(),
    getIncomeColumn(currency),
    getExpenseColumn(currency),
    getRateColumn(),
    getBalanceColumn(currency, { strong: true }),
    getDeleteActionColumn(onDelete),
  ];
}